module.exports = __webpack_public_path__ + "img/creat.1768119790257.png";